import { render, staticRenderFns } from "./CustomInterestRatesTable.vue?vue&type=template&id=39a324cc&scoped=true"
import script from "./CustomInterestRatesTable.vue?vue&type=script&lang=js"
export * from "./CustomInterestRatesTable.vue?vue&type=script&lang=js"
import style0 from "./CustomInterestRatesTable.vue?vue&type=style&index=0&id=39a324cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a324cc",
  null
  
)

export default component.exports